export default __webpack_public_path__ + "assets/models/65167645ce1cd853e841a765486287d4.glb";